import React, { useState } from 'react'
import { getImages } from '../../Common/const';
import RangeSlider from "react-range-slider-input";

const MoreFilterModal = ({
    close,
    numberFormatter,
    handlePriceSliderChange,
    handleMileageSliderChange,
    priceFilterData,
    mileageFilterData,
    isMobile,
    locationFilters,
    setLocationFilters,
    clearAllFilters,
    currentFilterData,
    setCurrentFilterData
}) => {

    const [transmissionFilters, setTransmissionFilters] = useState(currentFilterData.transmission);
    const [bodystyleFilters, setBodystyleFilters] = useState(currentFilterData.body_style);
    const [colorFilters, setColorFilters] = useState(currentFilterData.exterior_color);


    const handleFilterChange = (index, field) => {
        const filter_data = [...currentFilterData[field]];
        filter_data[index].isSelected = !filter_data[index].isSelected;

        //console.log("setting current filters handleFilterChange");
        setCurrentFilterData({ ...currentFilterData, [field]: filter_data });
    }


    return (
        <>
            <div className="modal-content">
                {isMobile &&
                    <div className="modal-header">
                        <h1 className="modal-title filter-modal-title text-uppercase font-1-2em fw-300 w-100 text-center">
                            Refine Search
                        </h1>
                        <button className="sm-box-close" type="button" onClick={close}>
                            <img src={getImages('white-close.svg')} />
                        </button>
                    </div>
                }
                <div className="modal-body px-md-5 py-md-5 px-3 py-4">
                    {!isMobile && (
                        <>
                            <h1 className="modal-title filter-modal-title fw-300 text-uppercase font-1-9em mb-5">
                                Refine your Search
                            </h1>
                            <button className="sm-box-close" type="button" onClick={close}>
                                <img src={getImages('white-close.svg')} />
                            </button>
                        </>
                    )}
                    <div className='mt-md-4 d-md-flex rys-row gx-3'>
                        <div className='rys-col-1'>
                            <div className='more-filter-box'>
                                <div className='xs-title'>Price Range</div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        value={[priceFilterData.current_min, priceFilterData.current_max]}
                                        onInput={handlePriceSliderChange}
                                        min={priceFilterData.min}
                                        max={priceFilterData.max}
                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{numberFormatter(priceFilterData.current_min, true)}</div>
                                        <div>{numberFormatter(priceFilterData.current_max, true)}</div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between mt-3'>
                                        <div>
                                            <input
                                                type="text"
                                                value={priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)}
                                                className='pr-input-field'
                                                readOnly
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                value={priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)}
                                                className='pr-input-field'
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='rys-col-1'>
                            <div className='more-filter-box'>
                                <div className='xs-title'>Miles Range</div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        value={[mileageFilterData.current_min, mileageFilterData.current_max]}
                                        onInput={handleMileageSliderChange}
                                        min={mileageFilterData.min}
                                        max={mileageFilterData.max}
                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{numberFormatter(mileageFilterData.current_min)}</div>
                                        <div>{numberFormatter(mileageFilterData.current_max)}</div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between mt-3'>
                                        <div>
                                            <input
                                                type="text"
                                                value={mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)}
                                                className='pr-input-field'
                                                readOnly
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                value={mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)}
                                                className='pr-input-field'
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='rys-col-2'>
                            <div className='more-filter-box h-100'>
                                <div className='xs-title mb-3'>Location</div>
                                <div className='sl-card-box'>
                                    <div className="custom-checkbox condition-checkbox w-100 mb-4">
                                        <input
                                            type="checkbox"
                                            name="condition"
                                            value="Tampa, FL"
                                            id='location1'
                                            checked={locationFilters.includes("Tampa, FL")}
                                            // checked={true}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setLocationFilters([...locationFilters, "Tampa, FL"]);
                                                } else {
                                                    setLocationFilters(locationFilters.filter(condition => condition !== "Tampa, FL"));
                                                }
                                            }}
                                        />
                                        <label htmlFor="location1" className='w-100'>Tampa, FL</label>
                                    </div>
                                    <div className="custom-checkbox condition-checkbox w-100">
                                        <input
                                            type="checkbox"
                                            name="condition"
                                            value="San Clemente, CA"
                                            id='location2'
                                            checked={locationFilters.includes("San Clemente, CA")}
                                            // checked={true}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setLocationFilters([...locationFilters, "San Clemente, CA"]);
                                                } else {
                                                    setLocationFilters(locationFilters.filter(condition => condition !== "San Clemente, CA"));
                                                }
                                            }}
                                        />
                                        <label htmlFor="location2" className='w-100'>San Clemente, CA</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-md-4 d-md-flex rys-row gx-3'>
                        <div className='rys-col-1'>
                            <div className='more-filter-box pe-2'>
                                <div className='xs-title mb-3'>Transmission</div>
                                <div className='sl-chk-scroll'>
                                    {currentFilterData && 'transmission' in currentFilterData && currentFilterData.transmission.map((item, index) => (
                                        <div className='sl-more-chk-box sl2-chk-box d-flex align-items-center justify-content-between mb-2'
                                            key={item.name}>
                                            <div className='pe-md-2'>
                                                <div className='sm-title fw-700 mb-0 text-start'>{item.name}</div>
                                                <div className='xs-title fw-300 font-13 text-white'>{item.available} available</div>
                                            </div>
                                            <div>
                                                <div
                                                    className="custom-checkbox condition-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-transmission-${index}`}
                                                        checked={item.isSelected}
                                                        onChange={() => handleFilterChange(index, 'transmission')}
                                                    />
                                                    <label htmlFor={`checkbox-transmission-${index}`} className="w-100">

                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='rys-col-1'>
                            <div className='more-filter-box pe-2'>
                                <div className='xs-title mb-3'>Bodystyle</div>
                                <div className='sl-chk-scroll'>
                                    {currentFilterData && 'body_style' in currentFilterData && currentFilterData.body_style.map((item, index) => (
                                        <div className='sl-more-chk-box sl2-chk-box d-flex align-items-center justify-content-between mb-2'
                                            key={item.name}>
                                            <div className='pe-md-2'>
                                                <div className='sm-title fw-700 mb-0 text-start'>{item.name}</div>
                                                <div className='xs-title fw-300 font-13 text-white'>{item.available} available</div>
                                            </div>
                                            <div>
                                                <div
                                                    className="custom-checkbox condition-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-body-${index}`}
                                                        checked={item.isSelected}
                                                        onChange={() => handleFilterChange(index, 'body_style')}
                                                    />
                                                    <label htmlFor={`checkbox-body-${index}`} className="w-100">

                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='rys-col-2'>
                            <div className='more-filter-box pe-2'>
                                <div className='xs-title mb-3'>Color</div>
                                <div className='sl-chk-scroll'>
                                    {/* {currentFilterData && 'exterior_color' in currentFilterData && currentFilterData.exterior_color.map((item, index) => (
                                        <div
                                            key={index}
                                            className="custom-checkbox condition-checkbox mb-2"
                                        >
                                            <input
                                                type="checkbox"
                                                id={`checkbox-color-${index}`}
                                                checked={item.isSelected}
                                                onChange={() => handleFilterChange(index,'exterior_color')}
                                            />
                                            <label htmlFor={`checkbox-color-${index}`} className="w-100">
                                                {item.name}
                                            </label>
                                        </div>
                                    ))} */}
                                    {currentFilterData?.exterior_color
                                        ?.map((item, originalIndex) => ({
                                            ...item,
                                            originalIndex,
                                        }))
                                        .filter((item, index, self) => {
                                            if (!item || !item.name?.trim()) return false;

                                            return (
                                                self.findIndex(
                                                    (el) => el?.name?.trim() === item.name.trim()
                                                ) === index
                                            );
                                        })
                                        .map((item) => (
                                            <div
                                                key={item.originalIndex}
                                                className="custom-checkbox condition-checkbox mb-2"
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-color-${item.originalIndex}`}
                                                    checked={item.isSelected}
                                                    onChange={() =>
                                                        handleFilterChange(item.originalIndex, "exterior_color")
                                                    }
                                                />
                                                <label
                                                    htmlFor={`checkbox-color-${item.originalIndex}`}
                                                    className="w-100"
                                                >
                                                    {item.name}
                                                </label>
                                            </div>
                                        ))}




                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='text-center mt-md-5 mt-4'>
                        <button className="black-red-btn text-uppercase me-md-4 me-3" type="button" onClick={() => { clearAllFilters() }}>Clear All</button>
                        <button className="black-red-btn text-uppercase" type="button" onClick={close}>View Matches</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MoreFilterModal